var html = document.documentElement;
var body = document.body;
var timeout;
var st = 0;

darkPage();
categoryNav();
initAccordion();
initSmoothScrollLinks();
initBackToTop();

// Call the function after the DOM is loaded
document.addEventListener('DOMContentLoaded', calculateTotalMiles);

dropdown(false);
pagination(false);

function portalButton() {
    'use strict';
    st = window.scrollY;

    if (st > 300) {
        body.classList.add('portal-visible');
    } else {
        body.classList.remove('portal-visible');
    }
}

function featured() {
    'use strict';
    var feed = document.querySelector('.featured-feed');
    if (!feed) return;

    tns({
        container: feed,
        controlsText: [
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M20.547 22.107L14.44 16l6.107-6.12L18.667 8l-8 8 8 8 1.88-1.893z"></path></svg>',
            '<svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M11.453 22.107L17.56 16l-6.107-6.12L13.333 8l8 8-8 8-1.88-1.893z"></path></svg>',
        ],
        gutter: 24,
        loop: false,
        nav: false,
        mouseDrag: true,
        responsive: {
            0: {
                items: 2,
            },
            768: {
                items: 2,
            },
            992: {
                items: 2,
            },
        },
    });
}

function darkPage() {
    var isDark = body.classList.contains('tag-hash-dark') ? 'dark' : 'light';
    html.classList.add(`${isDark}-page`);
}

function footerGroup() {
    const footerNav = document.querySelector(".footer-nav");
    if (!footerNav) return;
    
    const items = document.querySelectorAll(".footer-nav .nav li");

    const groups = [];
    let index = null;
    items.forEach(item => {
        const text = item.textContent.trim();
        const PREFIXFOOTERHEADER = "#";
        if (text.includes(PREFIXFOOTERHEADER)) {
            index = index === null ? 0 : ++index;
            groups[index] = { header: "", items: [] };
            groups[index].header = text.slice(PREFIXFOOTERHEADER.length);
        } else {
            groups[index].items.push({ text, link: item.childNodes[0].href });
        }
    })
    document.querySelector(".footer-nav ul.nav").remove();
    groups.forEach((group) => {
        const div = document.createElement('div');
        const h6 = document.createElement('h6');
        h6.classList.add("footer-group-header", "section-title");
        h6.innerHTML = group.header;
        const ul = document.createElement("ul");
        ul.classList.add("nav");
        group.items.forEach((item) => {
            const li = document.createElement("li");
            li.innerHTML = `<a href="${item.link}">${item.text}</a>`;
            ul.append(li);
        })
        div.append(h6, ul);
        footerNav.appendChild(div);
    });
}

function categoryNav() {
    var currentPageURL = window.location.pathname;

    // Get all <a> tags inside the .blog-navbar div
    var navbarLinks = document.querySelectorAll('.blog-navbar a');

    // Loop through each <a> tag
    navbarLinks.forEach(function(link) {
        // Check if the href attribute matches the current page URL
        if (link.getAttribute('href') === currentPageURL) {
            // Add the is-active class
            link.classList.add('is-active');
        }
    });
}

function initAccordion() {
    'use strict';
    var accordionItems = document.querySelectorAll('.accordion-item');
    if (!accordionItems.length) return;

    accordionItems.forEach(function(item) {
        var header = item.querySelector('.accordion-header');
        
        header.addEventListener('click', function() {
            // Close all other items
            accordionItems.forEach(function(otherItem) {
                if (otherItem !== item && otherItem.classList.contains('active')) {
                    otherItem.classList.remove('active');
                    otherItem.querySelector('.accordion-content').style.maxHeight = null;
                }
            });

            // Toggle the clicked item
            item.classList.toggle('active');
            var content = item.querySelector('.accordion-content');
            
            if (item.classList.contains('active')) {
                content.style.maxHeight = content.scrollHeight + 'px';
            } else {
                content.style.maxHeight = null;
            }
        });
    });
}

function initSmoothScrollLinks() {
    const smoothScrollLinks = document.querySelectorAll('.u-permalink');
    
    if (smoothScrollLinks.length === 0) return;

    smoothScrollLinks.forEach(link => {
        link.addEventListener('click', function(e) {
            const href = this.getAttribute('href');
            
            // Only prevent default and apply smooth scroll for hash links
            if (href.startsWith('#')) {
                e.preventDefault();
                const targetId = href.substring(1);
                const targetElement = document.getElementById(targetId);
                
                if (targetElement) {
                    // Update the URL with the hash
                    history.pushState(null, null, href);
                    
                    targetElement.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
            // For non-hash links, let the default behavior occur (navigate to the article)
        });
    });

    // Handle incoming hash links
    if (window.location.hash) {
        const targetElement = document.getElementById(window.location.hash.substring(1));
        if (targetElement) {
            setTimeout(() => {
                targetElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }, 300);
        }
    }
}

function initBackToTop() {
    const backToTopButtons = document.querySelectorAll('.back-to-top');
    const journalWrapper = document.getElementById('journal-wrapper');
    
    if (backToTopButtons.length === 0 || !journalWrapper) return;

    backToTopButtons.forEach(button => {
        button.addEventListener('click', function(e) {
            e.preventDefault();
            const offset = 32;
            const journalPosition = journalWrapper.getBoundingClientRect().top + window.scrollY - offset;
            
            window.scrollTo({
                top: journalPosition,
                behavior: 'smooth'
            });
        });
    });
}

function calculateTotalMiles() {
    // Update all accordion totals with their individual tag totals
    const accordions = document.querySelectorAll('.accordion');
    accordions.forEach(accordion => {
        const items = accordion.querySelectorAll('.accordion-content-item');
        let tagTotal = 0;
        
        items.forEach(item => {
            const milesElement = item.querySelector('.accordion-content-miles');
            const miles = parseFloat(milesElement.textContent) || 0;
            tagTotal += miles;
        });
        
        const totalMilesElement = accordion.querySelector('.total-miles');
        if (totalMilesElement) {
            totalMilesElement.textContent = Number.isInteger(tagTotal) ? 
                tagTotal.toString() : 
                tagTotal.toFixed(1);
        }
    });
}
